export default __webpack_public_path__ + "static/media/foods.87d4eb4e.jpg";